<template>
  <div class="yhc-component YhcInputRange" :class="parentClass">
    <PrivateLabel v-if="label" :labelClass="labelClass" :label="label"></PrivateLabel>
    <div class="content">
      <YhcInput
        class="range0"
        :placeholder="placeholder0 ? placeholder0 : `请输入${label}`"
        :value="value0"
        @input="change0"
        :disabled="onlyRead"
        :clearable="true"
        isMoneyData
      ></YhcInput>
      <span class="range1 yhc-fzc-black">-</span>
      <YhcInput
        class="range2"
        :placeholder="placeholder1 ? placeholder1 : `请输入${label}`"
        :value="value1"
        @input="change1"
        :disabled="onlyRead"
        :clearable="true"
        isMoneyData
      ></YhcInput>
    </div>

    <PrivateEndLabel
      v-if="endLabel"
      :isBtnEndLabel="isBtnEndLabel"
      :endLabelType="endLabelType"
      :endLabelStyle="endLabelStyle"
      :endLabel="endLabel"
      @tapEndLabel="$_tapEndLabel"
    ></PrivateEndLabel>
  </div>
</template>

<script>
import { isNaN, isNumber } from 'lodash';

import propsMixin from './componentsData/propsMixin';
import methodsMixin from './componentsData/methodsMixin';

import PrivateLabel from './componentsData/PrivateLabel.vue';
import PrivateEndLabel from './componentsData/PrivateEndLabel.vue';

let identifierName = 'YhcInputRange';

// 这个组件是基于input组件的组合
export default {
  name: identifierName,

  components: { PrivateLabel, PrivateEndLabel },
  mixins: [propsMixin, methodsMixin],

  data() {
    return {
      // devVal0: null,
      // devVal1: null
    };
  },

  props: {
    value0: {
      type: [String, Number],
    },
    value1: {
      type: [String, Number],
    },
    placeholder0: {
      type: String,
    },
    placeholder1: {
      type: String,
    },
  },
  computed: {},
  watch: {
    value0(newVal, oldVal) {
      this.change0(newVal);
    },
    value1(newVal, oldVal) {
      this.change1(newVal);
    },
  },
  methods: {
    change0(val) {
      let d = val * 1;
      if (isNumber(d) && !isNaN(d)) {
        this.$emit('change', [d, this.value1], this.index);
      } else {
        this.$emit('change', [0, this.value1], this.index);
      }
    },
    change1(val) {
      let d = val * 1;
      if (isNumber(d) && !isNaN(d)) {
        this.$emit('change', [this.value0, d], this.index);
      } else {
        this.$emit('change', [this.value0, 99999999999], this.index);
      }
    },
  },
  beforeCreate() {},
  created() {},
  mounted() {
    // this.devVal0 = this.value0
    // this.devVal1 = this.value1
    // this.init()
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import './componentsData/labelComponentCommonStyle';
// 差不多是src\components\componentsData\labelComponentCommonStyle.scss里面一模一样的了
.YhcInputRange {
  @include labelCommon();
  // 这里的content会和@include进来的那个同时存在的，不过优先级是这里，如果不行的话就用!important
  .content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .range0,
  .range2 {
    flex: 2.5;
    width: auto;
  }
  .range1 {
    flex: 1;
    text-align: center;
  }
}
</style>
